import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/CancelRounded';
import PendingRoundedIcon from '@mui/icons-material/PendingRounded';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { Typography } from '@mui/material';
import { FormatDateTimeInESTTimeZone } from 'src/utils/DateTimeHelper';
import { buildStepStatuses } from 'src/utils/Helper';

const QontoConnector = styled(props => <StepConnector {...props} />)(({ theme }) => {
  return {
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: 'calc(-50% + 16px)',
      right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#118D57',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#118D57',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderTopWidth: 3,
      borderRadius: 1,
    },
  };
});

const QontoStepIconRoot = styled('div')(({ theme }) => ({
  color: '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  '& .QontoStepIcon-completedIcon': {
    color: '#118D57',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-pendingIcon': {
    color: '#FFAB00',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-partialIcon': {
    color: '#3f51b5',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  ...theme.applyStyles('dark', {
    color: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: '#118D57',
      },
    },
  ],
}));

function QontoStepIcon(props) {
  const { active, className, status } = props;
  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {status === 'failed' ? (
        <CloseIcon className='QontoStepIcon-completedIcon' style={{ color: 'red' }} />
      ) : status === 'done' ? (
        <Check className='QontoStepIcon-completedIcon' />
      ) : status === 'queue' ? (
        <PendingRoundedIcon className='QontoStepIcon-pendingIcon' />
      ) : status === 'partial success' ? (
        <PendingRoundedIcon className='QontoStepIcon-partialIcon' />
      ) : (
        <div className='QontoStepIcon-circle' />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  status: PropTypes.string,
};

const steps = ['FITHub', 'Eloquence', 'Retailers'];

function PricelogStatusStepper({ row }) {
  // Compute step statuses only when row changes
  const stepStatuses = React.useMemo(() => buildStepStatuses(row), [row]);

  // Active step = last meaningful status
  const activeStep = React.useMemo(
    () => stepStatuses.findLastIndex(step => ['queue', 'failed', 'done', 'partial success'].includes(step?.status)),
    [stepStatuses]
  );

  return (
    <Stack sx={{ width: '100%' }} spacing={4}>
      <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              slots={{ stepIcon: QontoStepIcon }}
              slotProps={{ stepIcon: { status: stepStatuses[index]?.status } }}
            >
              <Typography variant='caption'>{label}</Typography>
              <br />
              <Typography variant='caption'>
                {stepStatuses[index]?.updatedAt &&
                  FormatDateTimeInESTTimeZone(stepStatuses[index].updatedAt, 'MM/DD/YYYY HH:mm')}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}

export default React.memo(PricelogStatusStepper);
